import React, { useEffect, useMemo, useState } from "react"
import useReportColumns from "hooks/useReportColumns"
import { REPORT_COLUMN_KEYS } from "config/reportColumnDefinitions"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { useDispatch, useSelector } from "react-redux"
import {
  exportMonitorConsumptionReports,
  getMonitorConsumptionReports,
} from "store/monitor-reports/monitor-report-action"
import {
  getMonitorIps,
  getMonitorItemCategories,
  getMonitorProjects,
} from "store/monitor-dashboard/monitor-dashboard-action"
import MonitorConsumptionReportListComponent from "components/MonitorReports/Consumption"

const MonitorConsumptionReportList = ({ from }) => {
  // Meta Title
  document.title = "Consumption Reports"

  const dispatch = useDispatch()

  // get consumptions
  const consumptions = useSelector(
    state => state.monitorReports.monitorConsumptionReport
  )

  // Current status of the export process for the consumption report, retrieved from the Redux store
  const exportStatus = useSelector(
    state => state.monitorReports.monitorConsumptionExport
  )

  const [according, setAccording] = useState({ order: "desc", name: "date" })
  const [advnacedSearch, setAdvancedSearch] = useState({})
  const { columns, visibleColumns, visibleKeys, toggleColumn, moveColumnToIndex } = useReportColumns(
    REPORT_COLUMN_KEYS.MONITOR_CONSUMPTION
  )

  const [pageNumber, setPageNumber] = useState(20)

  // Fetches new activity logs when a page number is clicked
  const onPageClick = link => {
    dispatch(
      getMonitorConsumptionReports(
        link.url,
        pageNumber,
        according,
        advnacedSearch
      )
    )
  }

  // Updates the number of rows displayed based on user selection (e.g., 10, 20, 50)
  const onChangeRowNumber = value => {
    setPageNumber(value)
  }

  // Updates the ordering based on user selection
  const onChangeOrdering = value => {
    if (value.order) {
      setAccording(prev => {
        return { ...prev, order: value.order }
      })
    }
    if (value.name) {
      setAccording(prev => {
        return { ...prev, name: value.name }
      })
    }
  }

  // fetch new Provider Distribution Action Requests based page number or according changes
  useEffect(() => {
    dispatch(
      getMonitorConsumptionReports(
        undefined,
        pageNumber,
        according,
        advnacedSearch
      )
    )
  }, [according, pageNumber])

  // fetch new item categories and IPs
  useEffect(() => {
    dispatch(getMonitorItemCategories())
    dispatch(getMonitorIps())
  }, [])

  // Updates search value when a new search is performed
  const onSearchHandler = data => {
    setAdvancedSearch(data)
    dispatch(
      getMonitorConsumptionReports(undefined, pageNumber, undefined, data)
    )
  }

  // Trigger export process when Export button is clicked
  const onExportBtnClick = () => {
    dispatch(exportMonitorConsumptionReports(according, advnacedSearch, visibleKeys))
  }

  return (
    <React.Fragment>
      {from !== "Dashboard" && (
        <Breadcrumbs title={"Monitor"} breadcrumbItem={"Consumption Reports"} />
      )}
      {from === "Dashboard" && (
        <div>
          <span style={{ fontSize: 24, marginBottom: 20 }}>
            Consumption Report
          </span>
          <br />
        </div>
      )}

      {/* Monitor Consumption Report Component  */}
      <MonitorConsumptionReportListComponent
        data={consumptions?.data}
        error={consumptions?.error}
        loading={consumptions?.loading}
        onChangeOrdering={onChangeOrdering}
        onSearchHandler={onSearchHandler}
        onExportBtnClick={onExportBtnClick}
        exportStatus={exportStatus}
        from={from}
        onPageClick={onPageClick}
        onChangeRowNumber={onChangeRowNumber}
        columns={columns}
        visibleColumns={visibleColumns}
        onToggleColumn={toggleColumn}
        onReorder={moveColumnToIndex}
      />
    </React.Fragment>
  )
}

export default MonitorConsumptionReportList
